// extracted by mini-css-extract-plugin
export default {"placeholder":"index_placeholder_LGuZK","wrap":"index_wrap_D9yEu","wrapLogo":"index_wrapLogo_bm6xS","wrapBtn":"index_wrapBtn_jNgvu"};